<style scoped>
.full-layout {
	position: fixed;
	inset: 0;
}

.topbar {
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	z-index: 20;
}
</style>

<template>
	<div class="full-layout">
		<div v-if="$slots.topbar" class="topbar">
			<slot name="topbar" />
		</div>
		<slot />
	</div>
</template>
